/** Dispatched when public guest session flag changes (e.g. App viewMode). */
export const PUBLIC_GUEST_ROUTE_EVENT = 'kp-public-guest-route';

let guestSessionActive = false;

/**
 * App sets this while public online / QR / booking views are mounted.
 * Needed after Windcave HPP strips query params (?wc_return) but viewMode stays `online`.
 */
export function setPublicGuestOrderingSessionActive(active: boolean): void {
  if (guestSessionActive === active) return;
  guestSessionActive = active;
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event(PUBLIC_GUEST_ROUTE_EVENT));
  }
}

function parseLocationSearch(): string {
  if (typeof window === 'undefined') return '';
  const hash = window.location.hash || '';
  const hashQuery = hash.startsWith('#') ? hash.slice(1) : hash;
  return window.location.search || (hashQuery.includes('=') ? `?${hashQuery}` : '');
}

/** True on public guest flows — POS soft keyboard must not appear (native keyboard only). */
export function isPublicGuestOrderingRoute(): boolean {
  if (guestSessionActive) return true;
  if (typeof window === 'undefined') return false;
  try {
    const host = window.location.hostname.toLowerCase();
    const path = (window.location.pathname || '/').replace(/\/$/, '') || '/';
    const search = parseLocationSearch();
    const params = new URLSearchParams(search.startsWith('?') ? search : `?${search}`);
    const wcReturn = params.get('wc_return');
    if (wcReturn === 'approved' || wcReturn === 'declined' || wcReturn === 'cancelled') {
      return true;
    }
    const hash = window.location.hash || '';
    const hashQuery = hash.startsWith('#') ? hash.slice(1) : hash;
    return (
      host.startsWith('order.') ||
      path === '/order' ||
      path === '/book' ||
      search.includes('view=online') ||
      search.includes('view=book') ||
      search.includes('view=customer') ||
      hashQuery.includes('view=online') ||
      hashQuery.includes('view=book') ||
      hashQuery.includes('view=customer')
    );
  } catch {
    return false;
  }
}
